import React from 'react';
import { Search, ShieldCheck, MapPin, Wrench, Package } from 'lucide-react';
const CHIPS = [{
  label: 'Complete mailbox system',
  href: '/6m8/mailboxes/complete-mailbox-post-system.html'
}, {
  label: 'Locking mailbox',
  href: '/6m8/mailboxes/locking-mailboxes.html'
}, {
  label: 'Commercial CBU',
  href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html'
}, {
  label: 'Replacement part',
  href: '/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html'
}, {
  label: 'Address plaque',
  href: '/6m8/address-plaques-and-house-numbers.html'
}, {
  label: 'Mailbox post',
  href: '/6m8/mailbox-posts.html'
}];
export function Hero() {
  return <section className="relative bg-brand-background overflow-hidden border-b border-brand-border" data-id="element-339">
      <div className="max-w-7xl mx-auto px-4 py-8 lg:py-12" data-id="element-340">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-341">
          {/* Left Column: Content */}
          <div className="lg:col-span-7 relative z-10" data-id="element-342">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-343">
              Residential, commercial & custom mailbox systems
            </span>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-4 leading-tight text-balance" data-id="element-344">
              The Right Mailbox for Your Home, Community, or Business
            </h1>

            <p className="text-base lg:text-lg text-brand-muted mb-6 leading-relaxed text-balance max-w-2xl" data-id="element-345">
              Shop residential mailboxes, commercial delivery systems,
              replacement parts, address plaques, signs, lighting, and exterior
              accents — with expert help before you order.
            </p>

            {/* Hero Search Panel */}
            {/* TODO: wire form action to Website Forge search endpoint */}
            <form role="search" onSubmit={e => e.preventDefault()} className="bg-white p-2 rounded-lg shadow-sm border border-brand-border mb-3 flex flex-col sm:flex-row gap-2 max-w-2xl" data-id="element-346">
              <div className="relative flex-grow" data-id="element-347">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-348" />
                <input type="text" aria-label="Search 1,700+ products by name, brand, part, or spec" placeholder="Search 1,700+ products by name, brand, part, or spec" className="w-full pl-10 pr-4 py-3 rounded-md border-none focus:ring-2 focus:ring-brand-maroon/50 bg-transparent text-brand-charcoal placeholder-gray-500 font-medium" data-id="element-349" />
              </div>
              <button type="submit" aria-label="Search" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-8 py-3 rounded-md font-semibold transition-colors whitespace-nowrap shadow-sm" data-id="element-350">
                Search
              </button>
            </form>

            {/* Quick Chips */}
            <div className="flex flex-wrap gap-2 mb-8 max-w-2xl" data-id="element-351">
              {CHIPS.map(chip => <a key={chip.label} href={chip.href} className="text-xs font-medium bg-white hover:bg-brand-goldWash text-brand-muted hover:text-brand-charcoal hover:border-brand-gold px-3 py-1.5 rounded-full border border-brand-border transition-colors" data-id="element-352">
                  {chip.label}
                </a>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-4" data-id="element-353">
              <a href="#shop-by-need" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-354">
                Shop by Project
              </a>
              <a href="/ContactUs.html" className="bg-white hover:bg-brand-panel text-brand-charcoal border border-brand-border px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-355">
                Get Help Choosing
              </a>
              <span className="hidden sm:inline text-gray-400" data-id="element-356">or</span>
              <a href="tel:301-620-7585" className="text-brand-charcoal hover:text-brand-maroon font-semibold flex items-center gap-2 transition-colors" data-id="element-357">
                Call 301-620-7585
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="lg:col-span-5 relative hidden lg:block h-full min-h-[440px]" data-id="element-358">
            <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-sm border border-brand-border" data-id="element-359">
              <img src="https://cdn.magicpatterns.com/uploads/vFqrVUQeADTTrZFkvijeyA/01-hero-mailbox-scene.png" alt="Black residential mailbox in front of a landscaped home." className="w-full h-full object-cover object-center" data-id="element-360" />
            </div>
          </div>
        </div>
      </div>

      {/* Trust Strip - Compact */}
      <div className="bg-white border-t border-brand-border" data-id="element-361">
        <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-362">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-x-8 gap-y-3 text-xs lg:text-sm text-brand-charcoal font-medium" data-id="element-363">
            <div className="flex items-center gap-2" data-id="element-364">
              <Package size={16} className="text-brand-maroon" data-id="element-365" />
              <span data-id="element-366">Nationwide shipping</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-367"></div>
            <div className="flex items-center gap-2" data-id="element-368">
              <Wrench size={16} className="text-brand-maroon" data-id="element-369" />
              <span data-id="element-370">Select-area installation</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-371"></div>
            <div className="flex items-center gap-2" data-id="element-372">
              <ShieldCheck size={16} className="text-brand-maroon" data-id="element-373" />
              <span data-id="element-374">22+ years of expertise</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-375"></div>
            <div className="flex items-center gap-2" data-id="element-376">
              <MapPin size={16} className="text-brand-maroon" data-id="element-377" />
              <span data-id="element-378">USPS-aware guidance</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}